module.exports = __webpack_public_path__ + "img/walk.98523200.svg";